module.exports = __webpack_public_path__ + "img/dev-mark.df152a6.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/dev-mark.svg
// module id = ./static/images/dev-mark.svg
// module chunks = 5